import { render } from "./CRMHigh.vue?vue&type=template&id=4f2de83d&scoped=true"
import script from "./CRMHigh.vue?vue&type=script&lang=js"
export * from "./CRMHigh.vue?vue&type=script&lang=js"

import "./CRMHigh.vue?vue&type=style&index=0&id=4f2de83d&scoped=true&lang=css"
import "./CRMHigh.vue?vue&type=style&index=1&id=4f2de83d&lang=css"
script.render = render
script.__scopeId = "data-v-4f2de83d"

export default script